import React from "react";
import { colors } from "../../constants/theme";

interface ButtonProps {
  onClick?: () => void;
  children?: React.ReactNode;
  kind?: "primary" | "outline";
  disabled?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ onClick, children, kind = "outline", disabled }) => (
  <button onClick={onClick} disabled={disabled} style={{ padding: "8px 12px", borderRadius: 8, border: kind === "primary" ? `1px solid ${colors.accent}` : `1px solid ${colors.border}`, background: disabled ? "#f3f3f3" : kind === "primary" ? colors.accent : colors.card, color: disabled ? colors.muted : kind === "primary" ? "#fff" : colors.text, cursor: disabled ? "not-allowed" : "pointer" }}>{children}</button>
);

